
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/principles",
      function () {
        return require("private-next-pages/principles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/principles"])
      });
    }
  